<template>
  <main class="aki-page-main">
    <slot></slot>
  </main>
</template>

<script>
export default {
  name: 'AkiPageMain'
}
</script>
